import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { catchError, map, mergeMap, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminUserControllerService {
  constructor(private http: HttpClient) { }

  createUser(body: any): Observable<any> {
    const coreAdminApiBaseUrl = environment.coreApiBaseUrl;
    const coreApiToken = localStorage.getItem('Authorization') || localStorage.getItem('token');
    const adminAuthorizationToken = 'Bearer ' + coreApiToken;
    const tenantPublicKey = environment.adminTenantPublicKey;
    const url = `${coreAdminApiBaseUrl}/tenants/users`;

    const payload = {
      ...body,
      usernameType: 'phone-number'
    };

    const headers = new HttpHeaders({
      'x-token-ready': 'true',
      Authorization: adminAuthorizationToken,
      'x-public-key': tenantPublicKey
    });

    return this.http.post(url, payload, { headers }).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        console.error('Error:', error);
        return of(null);
      }));
  }

  getUsers(): Observable<any[]> {
    const coreAdminApiBaseUrl = environment.coreApiBaseUrl;
    const coreApiToken = localStorage.getItem('Authorization') || localStorage.getItem('token');
    const adminAuthorizationToken = 'Bearer ' + coreApiToken;
    const tenantPublicKey = environment.adminTenantPublicKey;
    const url = `${coreAdminApiBaseUrl}/users`;

    const headers = new HttpHeaders({
      'x-token-ready': 'true',
      Authorization: adminAuthorizationToken,
      'x-public-key': tenantPublicKey
    });

    return this.http.get(url, { headers }).pipe(
      map((data: any[]) => {
        return data;
      }),
      catchError((error) => {
        console.error('Error:', error);
        return of([])
      })
    );
  }


  getUserActionLogs(): Observable<any[]> {
    const coreAdminApiBaseUrl = environment.coreApiBaseUrl;
    const coreApiToken = localStorage.getItem('Authorization') || localStorage.getItem('token');
    const adminAuthorizationToken = 'Bearer ' + coreApiToken;
    const tenantPublicKey = environment.adminTenantPublicKey;
    const url = `${coreAdminApiBaseUrl}/action-logs`;

    const headers = new HttpHeaders({
      'x-token-ready': 'true',
      Authorization: adminAuthorizationToken,
      'x-public-key': tenantPublicKey
    });

    return this.http.get(url, { headers }).pipe(
      map((data: any[]) => {
        return data;
      }),
      catchError((error) => {
        console.error('Error:', error);
        return of([])
      })
    );
  }


}
